import styled from 'styled-components';

// Styles
import { hoverCapable } from '../../../../../styles/hover';

// Types
import { thProps, thRightProps } from './types';

// Components
import DropDownInput from '../../../../inputs/DropDown/DropDownInput';
import { DropDownHeader } from '../../../../inputs/DropDown/DropDownInput/styles';

export const FiltersContainer = styled.div`
  display: flex;
  align-items: end;
  gap: ${({ theme }) => theme.spacing.m};
  div:last-child {
    flex: 1;
  }
`;

export const DropDownFilterStyled = styled(DropDownInput)`
  ${DropDownHeader} {
    height: 4.5rem;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.8rem;
`;

export const ContainerSearchBar = styled.div`
  width: 100%;
  max-width: 36rem;
`;

export const ContainerTables = styled.div`
  display: flex;
  gap: 1.8rem;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column;
    gap: 2.8rem;
  }
`;

export const SubContainer = styled.div`
  max-width: 80rem;
  flex: 1.5;
  overflow-y: auto;
  max-height: 19.1rem;
  background-color: ${({ theme }) => theme.colors.greyVerySoft};
  border-bottom: 0.1rem solid ${({ theme }) => theme.colors.greyLight};
  border-radius: 0.5rem 0.5rem 0 0;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    max-width: initial;
  }
`;

export const SubContainerRight = styled(SubContainer)`
  max-width: 60rem;
  min-height: 19.1rem;
  flex: 1;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    max-width: initial;
  }
`;

export const Table = styled.table`
  width: 100%;
  & * {
    white-space: nowrap;
  }
`;

export const TableRight = styled.table`
  width: 100%;
`;

export const Thead = styled.thead`
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: ${({ theme }) => theme.colors.greyDark};
`;

export const Tr = styled.tr``;

export const Th = styled.th<thProps>`
  padding: 0.2rem 0 0.2rem 1rem;
  text-align: left;
  &:first-of-type {
    padding-left: 1.4rem;
    min-width: 3rem;
    width: 3rem;
    text-align: center;
  }

  &:nth-of-type(2) {
    min-width: 9rem;
    width: 9rem;
  }

  &:nth-of-type(3) {
    min-width: 12rem;
    width: 12rem;
  }

  &:nth-of-type(4) {
    min-width: 15rem;
    width: 15rem;
  }

  &:last-of-type {
    padding-right: 1.4rem;
    min-width: 8rem;
    width: 8rem;
    text-align: center;
  }
`;

export const ThRightTable = styled.th<thRightProps>`
  padding: 0.2rem 0 0.2rem 1rem;
  &:first-of-type {
    padding-left: 1.4rem;
    min-width: 9rem;
    width: 9rem;
    text-align: left;
  }

  &:nth-of-type(2) {
    min-width: 12rem;
    width: 12rem;
    text-align: left;
  }

  &:nth-of-type(3) {
    min-width: 12rem;
    width: 12rem;
    text-align: left;
  }

  &:nth-of-type(4) {
    min-width: 8rem;
    width: 8rem;
    text-align: center;
  }

  &:last-of-type {
    padding-right: 1.4rem;
    min-width: 5rem;
    width: 5rem;
    text-align: center;
  }
`;

export const Td = styled.td<thProps>`
  padding: 0.65rem 0 0.65rem 1rem;
  &:first-of-type {
    padding-left: 1.4rem;
    text-align: center;
  }

  &:last-of-type {
    padding-right: 1.4rem;
    text-align: center;
  }
`;

export const TdRightTable = styled.td<thRightProps>`
  padding: 0.8rem 0 0.8rem 1rem;
  &:first-of-type {
    padding-left: 1.4rem;
  }

  &:nth-of-type(4) {
    text-align: center;
  }

  &:last-of-type {
    padding-right: 1.4rem;
    vertical-align: middle;
    text-align: center;
  }
`;

export const Img = styled.img`
  width: 1.5rem;
  height: 2rem;
  cursor: pointer;
`;

export const Tbody = styled.tbody``;

export const TbodyRight = styled.tbody``;

interface TrBodyProps {
  $highlighted?: boolean;
}

export const TrBody = styled.tr<TrBodyProps>`
  cursor: pointer;
  touch-action: manipulation;
  transition: background-color 0.2s ease;

  background-color: ${({ $highlighted, theme }) =>
    $highlighted ? theme.colors.greyLight : 'transparent'};

  /* Solo con puntero fino: en táctil el :hover se queda pegado tras
     el toque (ver styles/hover.ts). */
  ${hoverCapable} {
    &:hover {
      background-color: ${({ theme }) => theme.colors.greyLight};
    }
  }
`;

export const StyledInput = styled.input`
  width: 100%;
  padding: 0;
  border: none;
  appearance: none;
  background: transparent;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  &[type='number'] {
    -moz-appearance: textfield;
  }
  &:focus {
    outline: none;
  }

  /* Truncamiento siempre activo para evitar overflow */
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  /* Prevenir scroll interno - campo de solo lectura visual */
  pointer-events: none;
  user-select: none;
`;

export const Input = styled.input`
  width: 100%;
  padding: 0;
  border: none;
  appearance: none;
  color: ${({ theme }) => theme.colors.black};
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  &[type='number'] {
    -moz-appearance: textfield;
  }
  &:focus {
    outline: none;
  }
`;
